import { createIcon } from '@chakra-ui/react'

export const ArkeoIcon = createIcon({
  displayName: 'Arkeo',
  path: (
    <g>
      <path
        fill='currentColor'
        d='M50.32.68C22.53.68 0 23.21 0 51s22.53 50.32 50.32 50.32S100.64 78.79 100.64 51 78.11.68 50.32.68Zm23.97 68.95H64.02c-2.55 0-4.9-1.35-6.19-3.54l-6.35-11.8s-.04-.06-.06-.1l4.56-2.64v-6.54l-5.66-3.27-5.66 3.27v6.54l4.56 2.64s-.04.06-.06.1l-6.35 11.8a7.173 7.173 0 0 1-6.19 3.54H26.35c-2.28 0-3.7-2.48-2.54-4.44l23.97-40.76c1.14-1.94 3.94-1.94 5.08 0l23.97 40.75c1.16 1.96-.26 4.44-2.54 4.44v.01Z'
      />
    </g>
  ),
  viewBox: '0 0 101 102',
})
